export default "__VITE_ASSET__Dhg6XIk9__"